import React, { useRef, useState} from 'react';
import { Menu } from 'primereact/menu';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Slider } from 'primereact/slider';
import { AppTopbarLogo }  from './AppTopbarLogo';

import AppSwitch from './AppSwitch'

import classNames from 'classnames';

export const AppTopbar = (props) => {

    const menu = useRef(null)
    const [infoVisible, setInfoVisible] = useState(false);
    const [configVisible, setConfigVisible] = useState(false);

    const items = [
        {
            label: 'Sair',
            icon: 'pi pi-fw pi-power-off',
            command: () => {
                props.logout()
            }
        }
    ]
  
    const onInfo = () =>{
        setInfoVisible(true)
        return null;
    }

    const onConfig = () =>{
        setConfigVisible(true)
        return null;
    }
    
    const intervaloRolagem = (valor) =>{
        if(!valor){
            return 0
        }
        
        let result = (Number(valor) / 1000)
        if (!isNaN(result)){ 
            return (result).toFixed(2);
        }
        return 0
    }
    
    const home = { icon: 'pi pi-home', command: () => props.goHome() }

    const wrapperTopBarMenu = classNames("layout-topbar-menu",{
        "layout-topbar-menu-colapsed": props.sidebarIsVisible
    })

    return (
        <>
            <div className={"layout-topbar clearfix"}>
                {!props.sidebarIsVisible &&
                    <AppTopbarLogo nomeSistema={props.nomeSistema} class="p-grid p-justify-center container-logo logo-topbar"/>
                }
                {props.menu?
                    <div className={wrapperTopBarMenu}>
                        <button type="button" className="p-link layout-menu-button" onClick={props.onToggleMenu}>
                            <span className="pi pi-bars" />
                        </button>
                        <BreadCrumb model={props.breadcrumb} home={home} className="p-custom-breadcrumb" />
                    </div>
                :null}                
                <div className="layout-topbar-icons p-d-flex p-ai-center">
                    {props.perfil?
                        <Button type="button" className="p-button-rounded botao-usuario-topbar"
                            tooltip={props?.perfilNome} tooltipOptions={{ position: 'left' }}
                            onClick={e => menu.current.toggle(e)} aria-controls="popup_menu" aria-haspopup>
                            <span className="layout-topbar-icon icone-usuario" />
                        </Button>
                    :null}
                    {props.config &&                           
                        <i className="layout-topbar-info pi pi-cog" onClick={onConfig}></i>                    
                    }
                    {props.info &&                           
                        <i className="layout-topbar-info pi pi-info-circle" onClick={onInfo}></i>                    
                    }                    
                </div>                
                <Dialog visible={infoVisible} header="Informações do sistema" 
                        onHide={() => setInfoVisible(false)} breakpoints={{'960px': '75vw', '640px': '100vw'}} 
                        style={{width: '50vw'}}>
                    {props?.info || "Informações do sistema"} 
                    <p style={{marginTop:'10px', fontSize:'0.8em'}}>
                        Sistema desenvolvido pelo Tribunal Regional Eleitoral de Santa Catarina
                    </p>
                </Dialog>
                <Dialog visible={configVisible} header="Configurações" 
                        onHide={() => setConfigVisible(false)} breakpoints={{'960px': '75vw', '640px': '100vw'}} 
                        style={{width: '50vw'}}>
                    <div className="flex flex-column">
                        {props.rolagemAuto!==undefined &&
                            <div className="mt-5">
                                <div className="border-bottom-GrayLine">Controle de Rolagem </div>                                                                       
                                <AppSwitch className="ml-4" titulo="Rolagem automática" valor={props.rolagemAuto} setValor={props.setRolagemAuto}/>                 
                                                            
                                {props.rolagemAuto==true &&                                    
                                    <div className="ml-4 mt-5">
                                        <div>Intervalo de Rolagem: {intervaloRolagem(props.rolagemAutoIntervalo)} segundos</div>
                                        <Slider max={5000} value={props.rolagemAutoIntervalo} onChange={(e) => props.setRolagemAutoIntervalo(e.value)} />                                        
                                    </div>
                                }
                            </div>
                        }
                        {props.ordenaPorVoto!==undefined &&
                            <div className="mt-5">
                                <div className="border-bottom-GrayLine">Ordena Dados</div>                            
                                <AppSwitch className="ml-4" titulo="Ordenar por votos" valor={props.ordenaPorVoto} setValor={props.setOrdenaPorVoto}/>
                            </div>
                        }
                        <div className="mt-5 border-bottom-GrayLine">Controle de exibição</div>                           
                            {props.ocultaLidas!==undefined &&
                                <AppSwitch className="ml-4" titulo="Ocultar seções lidas" valor={props.ocultaLidas} setValor={props.setOcultaLidas}/>                                  
                            }
                            {props.ocultaNLidas!==undefined &&
                                <AppSwitch className="ml-4" titulo="Ocultar seções não lidas" valor={props.ocultaNLidas} setValor={props.setOcultaNLidas}/>       
                            }
                            {props.ocultaZonasConcluidas!==undefined &&
                                <AppSwitch className="ml-4" titulo="Ocultar Zonas Eleitorais com leituras concluídas" valor={props.ocultaZonasConcluidas} setValor={props.setOcultaZonasConcluidas}/>       
                            }
                    </div>
                    
                </Dialog>
            </div>
            <Menu model={items} popup ref={menu} id="popup_menu" />
        </>
    );
}
